import { render, staticRenderFns } from "./tooltipForms5Dialog.vue?vue&type=template&id=6d828970"
import script from "./tooltipForms5Dialog.vue?vue&type=script&lang=js"
export * from "./tooltipForms5Dialog.vue?vue&type=script&lang=js"
import style0 from "./tooltipForms5Dialog.vue?vue&type=style&index=0&id=6d828970&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports